export { default } from './TextLabel.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Notification/TextLabel/index.js